import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  ConcludeContainer,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function PilkingtonAR() {
  const ProjectBG = require("../../../../assets/videos/pilkington/poster.png");
  const T1 = require("../../../../assets/videos/pilkington/t1.png");
  const T2 = require("../../../../assets/videos/pilkington/t2.png");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="Pilkington AR"
      lead={
        <p>
          Mobile AR for immersive exploration: Museum and Fassade modes for
          exhibits, products, and façade design with realistic glass behavior.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/pilkington/1_Pilkington_Mirrorpane.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Museum mode</WorkSectionHeading>
          <p>
            Explore the German Mining Museum in Bochum in AR; place the
            Mirropane™ Chrome Spy installation at scale; access technical data;
            walk through the exhibit virtually.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <video controls poster={T2}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/pilkington/2_Pilkington_Fassade.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Fassade mode</WorkSectionHeading>
          <p>
            Design façades in AR with product information and specs; place a
            façade in your environment; compare glass options; simulate sun
            position and self-cleaning behavior.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <ConcludeContainer>
        <p>
          Pilkington AR bridges cultural storytelling and architectural
          decision-making through approachable augmented reality.
        </p>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "Pilkington AR" },
          {
            label: "Period",
            value: "06.2020 - 08.2020 & 07.2021 - 11.2021",
          },
          { label: "Client", value: "Pilkington" },
          { label: "Engine & Tools", value: "Unity, AR Foundation, C#" },
          { label: "Platform", value: "Mobile" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "AR" },
        ]}
      />
    </WorkProjectShell>
  );
}
